import React from 'react';

const ProgressIcon = () => {
  return (
    <svg viewBox="0 0 173.26 126.24" preserveAspectRatio="xMidYMin">
      <path fill="#fff" d="M19 26.87h135.34v72.5H19z"/>
      <path fill="#3cc" d="M18.96 26.87H154.3v72.5H18.96z"/>
      <path fill="#fff" d="M154.35 99.46H19V60.02l34.93-12.98 32.74 2.08 27.46-4.69 24.39 2.59 15.83-5.3v57.74z"/>
      <path fill="#9c3" d="M154.35 99.37H19V59.93l34.93-12.97 32.74 2.07 27.46-4.69 24.39 2.59 15.83-5.3v57.74z"/>
      <path fill="#f63" d="M154.3 99.37H18.96V84.84l34.93-13.03 32.74 2.74 27.45-14.88 24.39 8.65 15.83-12.7v43.75z"/>
      <path fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth=".5" d="M10.14 36.86h153.05M10.14 50.31h153.05M10.14 63.76h153.05M10.14 77.21h153.05M10.14 90.66h153.05"/>
      <path fill="none" stroke="#a9aeb7" strokeMiterlimit="10" d="M19 26.87h135.34v72.5H19z"/>
      <circle cx="52.86" cy="66.28" r="2.16" fill="#fff"/>
      <circle cx="96.55" cy="68.43" r="2.16" fill="#fff"/>
      <circle cx="133.56" cy="57.77" r="2.16" fill="#fff"/>
      <path fill="none" stroke="#fff" strokeMiterlimit="10" d="M52.86 66.28l43.69 2.15 37.01-10.66"/>
    </svg>
  );
}

export default ProgressIcon;